import styles from './style.styl'
import Section from '../section'

const StartDate = () => (
  <Section
    id={'date_price'}
    className={styles.startDate}
    title={`
        DATES <br/>
        & COST
      `}
    text='Start date: July 13th, 2025<br/>
      Cost: £35,000 (excl. VAT) for all 5 modules'

  />
)

export default StartDate



// WEBPACK FOOTER //
// ./components/start-date/index.js